import * as tslib_1 from "tslib";
import React, { Component } from 'react';
import { Prompt as PromptComponent } from 'react-router';

var Prompt =
/** @class */
function (_super) {
  tslib_1.__extends(Prompt, _super);

  function Prompt() {
    var _this = _super !== null && _super.apply(this, arguments) || this;
    /* allows to track that `beforeunload` event handler has been registered */


    _this.hasBeforeUnloadSubscription = false;

    _this.handleOnBeforeUnload = function (ev) {
      if (_this.props.block) {
        ev.returnValue = '';
        return ev.returnValue;
      }
    };

    _this.getMessage = function (location) {
      if (_this.props.onBlock) {
        _this.props.onBlock(location.pathname);
      }

      return false;
    };

    return _this;
  }

  Prompt.prototype.componentDidMount = function () {
    if (this.props.blockWindowUnload) {
      this.hasBeforeUnloadSubscription = true;
      window.addEventListener('beforeunload', this.handleOnBeforeUnload);
    }
  };

  Prompt.prototype.componentWillUnmount = function () {
    if (this.hasBeforeUnloadSubscription) {
      window.removeEventListener('beforeunload', this.handleOnBeforeUnload);
    }
  };

  Prompt.prototype.render = function () {
    return React.createElement(PromptComponent, {
      when: this.props.block,
      message: this.getMessage
    });
  };

  return Prompt;
}(Component);

export { Prompt };